import { getProportionSales, getSalesTrend, getSummary, getTopSearch, getUserActivity, getVisit } from 'APIs/dashboardMain'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { FAILURE, REQUEST, SUCCESS } from '../../../Stores'
import { hideOverlay, showModalMessage, showOverlay } from '../../store/actions'
import {
  GET_DATA_DASHBOARD,
  GET_DATA_TAB_CHART,
  GET_DATA_TOP_SEARCH
} from './constants'

export function* getDataDashboard({ payload }) {
  try {
    yield put(showOverlay())
    const { year, month, date, type, from, to } = payload
    const [proportionSales, summary, userActivity, salesTrend, visits, dataTopSearch] = yield all([
      call(getProportionSales),
      call(getSummary, { year, month, date }),
      call(getUserActivity, {
        type, from, to
      }),
      call(getSalesTrend, {
        type, from, to
      }),
      call(getVisit, {
        type, from, to
      }),
      call(getTopSearch)
    ])
    yield put({
      type: SUCCESS(GET_DATA_DASHBOARD),
      payload: { proportionSales, summary, userActivity, salesTrend, visits, dataTopSearch }
    })
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_DATA_DASHBOARD),
      error
    })
  }
}

export function* getDataTabChartSaga({ payload }) {
  try {
    yield put(showOverlay())
    const { type, from, to } = payload
    const [userActivity, salesTrend, visits] = yield all([
      call(getUserActivity, {
        type, from, to
      }),
      call(getSalesTrend, {
        type, from, to
      }),
      call(getVisit, {
        type, from, to
      })
    ])
    yield put({
      type: SUCCESS(GET_DATA_TAB_CHART),
      payload: {
        userActivity,
        salesTrend,
        visits
      }
    })
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_DATA_TAB_CHART),
      error
    })
  }
}

export function* getDataTopSearchSaga({ payload }) {
  try {
    const result = yield call(getTopSearch, payload)
    yield put({
      type: SUCCESS(GET_DATA_TOP_SEARCH),
      payload: result
    })
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_DATA_TOP_SEARCH),
      error
    })
  }
}

export default function* dashboardMainSaga() {
  yield takeLatest(REQUEST(GET_DATA_DASHBOARD), getDataDashboard)
  yield takeLatest(REQUEST(GET_DATA_TAB_CHART), getDataTabChartSaga)
  yield takeLatest(REQUEST(GET_DATA_TOP_SEARCH), getDataTopSearchSaga)
}
